import browserSessionStorage from "core/services/storageService/sessionStorage";

const getAuthData = () => browserSessionStorage.get("authorizationData")

export default getAuthData;